import React, { useState } from 'react';
import styles from './GiftItem.module.scss';
import { cartStore } from '../../hooks/cartStore';

// Define interfaces for the product structure
interface ProductVariant {
  price: number;
  compare_at_price: number;
}

interface ProductImage {
  src: string;
}

interface Product {
  title: string;
  images: ProductImage[];
  variants: ProductVariant[];
}

// Define props interface
interface GiftItemProps {
  product: Product;
  isLocked: boolean;
  isAddingGift: boolean;
  setIsAddingGift: (isAddingGift: boolean) => void;
}

export default function GiftItem({ product, isLocked, isAddingGift, setIsAddingGift }: GiftItemProps) {
  const imageUrl = product.images[0].src;
  const title = product.title;
  const originalPrice = product.variants[0].compare_at_price;
  const discountedPrice = product.variants[0].price;
  const discount = "100% OFF";

  // Function to handle adding the item to the cart
  const handleAddToCart = () => {
    setIsAddingGift(true);
    cartStore.addGiftItem(product).then(() => {
      cartStore.closeGiftPopup();
      if (window.location.pathname !== '/cart') {
        cartStore.openMiniCart();
      }
    }).finally(() => {
      setIsAddingGift(false);
    });
  };

  return (
    <div className={styles.giftItem}>
      <div className={styles.imageContainer}>
        <img src={imageUrl} alt={title} className={styles.giftImage} />
        <div className={styles.discountBadge}>{discount}</div>
      </div>
      <h3 className={styles.giftTitle}>{title}</h3>
      <div className={styles.priceContainer}>
        <s className={styles.originalPrice}>${originalPrice}</s>
        <span className={styles.discountedPrice}>${discountedPrice}</span>
      </div>
      {!isLocked && <button className={styles.addToCartButton} onClick={handleAddToCart} disabled={isAddingGift}>ADD TO CART</button>}
    </div>
  );
}

GiftItem.displayName = "GiftItem";
